document.addEventListener("DOMContentLoaded", (event) => {
  const showFilter = document.querySelector('#open-filters');
        hiddenFilters = document.querySelector('.cc-product-filter'),
        closeFilter = document.querySelector('#close-filters'),
        body = document.querySelector('body'),
        html = document.querySelector('html'),
        overlay = document.querySelector('.filter-overlay');

  if (showFilter && hiddenFilters) {
    const toggleFilters = (isOpen) => {
      hiddenFilters.classList.toggle('open', isOpen);
      body.classList.toggle('modal-active', isOpen);
      html.style.overflow = isOpen ? 'hidden' : 'auto';
      html.style.touchAction = isOpen ? 'none' : 'auto';
    };

    showFilter.addEventListener('click', (e) => {
      e.preventDefault();
      toggleFilters(true);
    });

    if (closeFilter) {
      closeFilter.addEventListener('click', (e) => {
        e.preventDefault();
        toggleFilters(false);
      });
    }

    if (overlay) {
      overlay.addEventListener('click', (e) => {
        e.preventDefault();
        toggleFilters(false);
      });
    }
  }
  
  const gridCollection = document.querySelectorAll('.collection-grid-var'),
        collection =  document.querySelector('.product-list');

  if (gridCollection && collection) {
    gridCollection.forEach((elem) => {
      elem.addEventListener('click', (e) => {
        gridCollection.forEach((item) => {
          item.classList.remove('active');
        })
        e.currentTarget.classList.add('active');
        const grid_items = e.currentTarget.getAttribute('data-grid');
        collection.setAttribute('data-grid', grid_items);
      })
    })
  }
});